import i18n from 'modules/core/lib/i18n'

import { InsightTableType } from 'modules/finance/components/FinancialWorkspace/types/table'
import { useOnExport } from 'modules/finance/components/FinancialWorkspacePayroll/exports/useExport'
import { usePayrollGroupData } from 'modules/finance/components/FinancialWorkspacePayroll/hooks/usePayrollGroupData'

import { GroupBySelector } from './components/GroupBy'
import { resolveTitle } from './const'
import { useUploadPayrollAction } from 'modules/finance/components/FinancialWorkspace/components/UploadPayroll/useUploadPayrollAction'
import { SOURCE } from 'modules/finance/components/FinancialWorkspacePayroll/components/Table/components/UploadPayroll'

export const useTableProps = () => {
  const action = useUploadPayrollAction({
    source: SOURCE,
    includeButtonIcon: true,
    insightTableType: InsightTableType.Payroll,
  })

  return {
    useOnExport,
    titleResolver: resolveTitle,
    groupByComponent: GroupBySelector,
    useDataFetch: usePayrollGroupData,
    emptyStateProps: {
      emoji: '📄',
      filtersEmoji: '🔍',
      actions: () => [
        {
          icon: action.icon,
          label: action.label,
          onClick: action.onClick,
          variant: 'outline' as const,
        },
      ],
      title: i18n.t('finance.financial_workspace.breakdown_table.empty_state.payroll.title'),
      description: i18n.t(
        'finance.financial_workspace.breakdown_table.empty_state.payroll.description'
      ),
    },
    type: InsightTableType.Payroll,
  }
}
